import React from 'react'
import TeamCard from './cards/team'

const AgentProfileTeam = ({ title, team }) => (
  <>
    {team?.acf?.team &&
      <section className='profile__team agent-profile'>
        <div className='profile__inner'>
          <div className='profile__team-body'>
            <div className='profile__menu'>
              <ul>
                <li className='active'>{ title }</li>
              </ul>
            </div>
            <div className="profile__members">
              {team.acf.team.map((el, i) => (
                <TeamCard {...el} {...el.acf} {...el.teamDetails} key={i} profile={true} />
              ))}
            </div>
          </div>
        </div>
      </section>
    }
  </>
)

AgentProfileTeam.defaultProps = {
  title: 'My team',
  team: null,
}

export default AgentProfileTeam